import React from "react";
import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Icon,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { Heart, Code } from "lucide-react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const Footer: React.FC = () => {
  // Dark mode color values
  const bgColor = useColorModeValue("gray.800", "gray.900");
  const textColor = useColorModeValue("white", "gray.100");
  const mutedTextColor = useColorModeValue("gray.400", "gray.500");
  const dividerColor = useColorModeValue("gray.600", "gray.700");
  const brandGradient = useColorModeValue(
    "linear(to-r, brand.300, brand.500)",
    "linear(to-r, brand.200, brand.400)"
  );

  return (
    <Box bg={bgColor} color={textColor} py={12}>
      <Container maxW="7xl">
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <VStack spacing={6}>
            <Text
              fontSize="2xl"
              fontWeight="bold"
              bgGradient={brandGradient}
              bgClip="text"
            >
              Jelili Abdullahi A.
            </Text>

            <Text textAlign="center" color={mutedTextColor} maxW="md">
              Dynamic Frontend Developer with 5+ years of experience building
              scalable web and mobile apps. Passionate about creating
              exceptional digital experiences with modern technologies.
            </Text>

            <Divider borderColor={dividerColor} />

            <HStack
              justify="space-between"
              w="full"
              flexDirection={{ base: "column", md: "row" }}
              spacing={{ base: 4, md: 0 }}
              align="center"
            >
              <HStack spacing={2} color={mutedTextColor}>
                <Text fontSize="sm">Made with</Text>
                <Icon as={Heart} w={4} h={4} color="red.400" />
                <Text fontSize="sm">and</Text>
                <Icon
                  as={Code}
                  w={4}
                  h={4}
                  color={useColorModeValue("brand.400", "brand.300")}
                />
                <Text fontSize="sm">by Jelili Abdullahi A.</Text>
              </HStack>

              <Text fontSize="sm" color={mutedTextColor}>
                © {new Date().getFullYear()} All rights reserved.
              </Text>
            </HStack>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default Footer;
